import { useState } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';
import { ApiError } from '@/lib/api/client';
import { Toaster } from '@/components/ui/toast';
import { router } from './routes';

export function App() {
  const [client] = useState(() => new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        // A 4xx is an answer, not a blip: retrying a 403 three times only delays the message.
        retry: (count, err) => !(ApiError.is(err) && err.statusCode < 500) && count < 2,
      },
    },
  }));
  return (
    <QueryClientProvider client={client}>
      <RouterProvider router={router} />
      <Toaster />
    </QueryClientProvider>
  );
}
